"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const vertical_icon_bar_styles_1 = require("../vertical_icon_bar/vertical_icon_bar.styles");
const app_text_1 = __importDefault(require("../typography/app_text"));
const NavIcon = ({ expanded, label, icon, onClick, testId }) => {
    return ((0, jsx_runtime_1.jsxs)(vertical_icon_bar_styles_1.VertNavIcon, Object.assign({ expanded: expanded, onClick: onClick, "data-testid": testId }, { children: [(0, jsx_runtime_1.jsx)(vertical_icon_bar_styles_1.VertNavIconWrapper, { children: icon }), (0, jsx_runtime_1.jsx)(app_text_1.default, Object.assign({ as: "p", screenReaderOnly: !expanded, style: {
                    marginLeft: '8px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }, color: "light", bold: true }, { children: label }))] }), label));
};
exports.NavIcon = NavIcon;
//# sourceMappingURL=nav_icon.js.map